import { format, isBefore } from "date-fns";

export const customerTableColumn = [
  { 
    field: "name", 
    headerName: "Name",
    minWidth: 130,
    flex: 1,
    sortable: true,
    filterable: false,
  },
  { 
    field: "mobile", 
    headerName: "Mobile",
    minWidth: 120,
    flex: 0.8,
    sortable: true,
    filterable: false,  
  },
  { 
    field: "email", 
    headerName: "Email",
    minWidth: 130,
    flex: 0.8,
    sortable: true,
    filterable: false,
  },
  { 
    field: "address", 
    headerName: "Address",
    minWidth: 200,
    flex: 1.5,
    sortable: true,
    filterable: false,
  },
  { 
    field: "country", 
    headerName: "Country",
    minWidth: 120,
    flex: 0.8,
    sortable: true,
    filterable: false,
    renderCell: (params) => {
      return <div>{params.row?.country?.name}</div>;
    },
  },
  { 
    field: "state", 
    headerName: "State",
    minWidth: 120,
    flex: 0.8,
    sortable: true,
    filterable: false,
    renderCell: (params) => {
      return params.row?.state?.name;
    },
  },
  { 
    field: "city", 
    headerName: "City",
    minWidth: 120,
    flex: 0.8,
    sortable: true,
    filterable: false,
    renderCell: (params) => {
      return params.row?.city?.name;
    },
  },
];

export const hotelTableColumn = [
  { 
    field: "name", 
    headerName: "Hotel Name",
    minWidth: 150,
    flex: 1,
    sortable: true,
    filterable: false,
  },
  { 
    field: "mobile", 
    headerName: "Mobile",
    minWidth: 120,
    flex: 0.8,
    sortable: true,
    filterable: false,
  },
  { 
    field: "email", 
    headerName: "Email",
    minWidth: 120,
    flex: 0.8,
    sortable: true,
    filterable: false,
  },
  { 
    field: "address", 
    headerName: "Address",
    minWidth: 200,
    flex: 1.5,
    sortable: true,
    filterable: false,
  },
  { 
    field: "country", 
    headerName: "Country",
    minWidth: 120,
    flex: 0.8,
    sortable: true,
    filterable: false,
    renderCell: (params) => {
      return params.row?.country?.name;
    },
  },
  { 
    field: "state", 
    headerName: "State",
    minWidth: 120,
    flex: 0.8,
    sortable: true,
    filterable: false,
    renderCell: (params) => {
      return params.row?.state?.name;
    },
  },
  { 
    field: "city", 
    headerName: "City",
    minWidth: 120,
    flex: 0.8,
    sortable: true,
    filterable: false,
    renderCell: (params) => {
      return params.row?.city?.name;
    },
  },
];

export const isDateDisabled = (date, minDate) => {
  const formattedDate = format(date, "yyyy-MM-dd");

  return isBefore(formattedDate, new Date(minDate));
};

export const getDaysCount = (startDate, endDate) => {
  const date1 = new Date(startDate);
  const date2 = new Date(endDate);

  const diffTime = Math.abs(date2 - date1);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return diffDays === 0 ? 1 : diffDays;
};

// MUI Data Grid column format
export const columns = [
  {
    field: 'bookingId',
    headerName: 'Booking ID',
    minWidth: 120,
    flex: 0.8,
    sortable: true,
    filterable: false,
  },
  {
    field: 'customerId',
    headerName: 'Customer',
    minWidth: 150,
    flex: 1,
    sortable: true,
    filterable: false,
    renderCell: (params) => {
      return <div>{params.row?.customers?.name}</div>;
    },
  },
  {
    field: 'phone',
    headerName: 'Phone',
    minWidth: 120,
    flex: 0.8,
    sortable: true,
    filterable: false,
    renderCell: (params) => {
      return <div>{params.row?.hotels?.phone}</div>;
    },
  },
  {
    field: 'hotelId',
    headerName: 'Hotel',
    minWidth: 150,
    flex: 1,
    sortable: true,
    filterable: false,
    renderCell: (params) => {
      return <div>{params.row?.hotels?.name}</div>;
    },
  },
  {
    field: 'travelAgentId',
    headerName: 'Travel Agent',
    minWidth: 150,
    flex: 1,
    sortable: true,
    filterable: false,
    renderCell: (params) => {
      return <div>{params.row?.travelPartner?.partnerName}</div>;
    },
  },
  {
    field: 'paymentTypeId',
    headerName: 'Booking Type',
    minWidth: 120,
    flex: 0.8,
    sortable: true,
    filterable: false,
    renderCell: (params) => {
      return <div>{params.row?.paymentTypes?.name}</div>;
    },
  },
  {
    field: 'pnr',
    headerName: 'PNR',
    minWidth: 100,
    flex: 0.6,
    sortable: true,
    filterable: false,
  },
  {
    field: 'checkingDate',
    headerName: 'Checkin Date',
    minWidth: 120,
    flex: 0.8,
    sortable: true,
    filterable: false,
  },
  {
    field: 'checkoutDate',
    headerName: 'Checkout Date',
    minWidth: 120,
    flex: 0.8,
    sortable: true,
    filterable: false,
  },
  {
    field: 'netAmt',
    headerName: 'Net Amount',
    minWidth: 120,
    flex: 0.8,
    sortable: true,
    filterable: false,
  },
  {
    field: 'saleAmt',
    headerName: 'Sale Amount',
    minWidth: 120,
    flex: 0.8,
    sortable: true,
    filterable: false,
  },
  {
    field: 'serviceCharge',
    headerName: 'Service Charge',
    minWidth: 120,
    flex: 0.8,
    sortable: true,
    filterable: false,
    renderCell: (params) => {
      return <div>0</div>;
    },
  },
  {
    field: 'totalMargin',
    headerName: 'Margin',
    minWidth: 100,
    flex: 0.6,
    sortable: true,
    filterable: false,
  },
];

export const statusList = [
  "New",
  "Modified",
  "Cancel",
  "No Show",
  "Refund",
  "PLB",
];

export const CONFIRMATION_ARR = [
  { value: 1, label: "Yes" },
  { value: 0, label: "No" },
];
